import React, { useState, useEffect } from 'react'
import Modal from "react-bootstrap/Modal";
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { useForm, Controller } from "react-hook-form";
import "bootstrap/dist/css/bootstrap.min.css";
import Select from 'react-select'
import { useAdminStore } from '../../stores';
import Swal from "sweetalert2";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import withReactContent from "sweetalert2-react-content";
//toast
const toastOptions = {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined
};

//sweetalert
const MySwal = withReactContent(Swal);
const AdminModal = ({ show, onClose, row, branches }) => {
  const { register, handleSubmit, watch, formState: { errors }, unregister, reset, control } = useForm();
  const [admin, setAdmin] = useState({ branch: {} });
  const branch = useAdminStore(state => state.branch);
  const editAdmin = useAdminStore(state => state.editAdmin);
  const duration = branch ? (branch.degree ? branch.degree.duration : 0) : 0;
  const OPTIONS = [...Array(duration || 0)].map((value, index) => ({ value: index + 1, label: index + 1 }));
  useEffect(() => {
    if (show) {
      row.fullName = row.firstName + " " + row.lastName;
      setAdmin(row);
      reset(row)
    }
    return () => {
      setAdmin({ branch: {} });
      reset({ branch: {} });
    }
  }, [show]);
  const onSubmit = async (formData) => {
    console.log(formData);
    try {
      const res = await fetch(`/api/super-admin/admins/${row._id}`, {
        method: "PUT",
        body: JSON.stringify({
          firstName: formData.fullName,
          years: formData.years,
          branch: branch._id
        }),
        headers: {
          'content-Type': "application/json"
        }
      });
      const data = await res.json();
      if (res.status !== 200) {
        toast.error(data.message,toastOptions);
        return;
      }
      console.log(data);
      // sweet alert
      toast.success(data.message,toastOptions);
      console.log(data.user);
      editAdmin({ ...data.user });
      onClose();
    } catch (error) {
      // toast.error
      console.log(error);
      toast.error(error.message,toastOptions);
    }

  };
  return (
    <>
    {/* <ToastContainer/> */}
      <Modal show={show} onHide={() => onClose()} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Admin details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            {/* <Form.Group className="mb-3" controlId="branch">
              <Form.Label>branch name</Form.Label>
              <Form.Control type="text" defaultValue={branch.name} {...register("name")} placeholder="Enter branch name" />
              <Form.Text className="text-muted">
                Write short only forms eg: CSE
              </Form.Text>
            </Form.Group> */}

            <Form.Group className="mb-3" controlId="admin">
              <Form.Label>HOD name</Form.Label>
              <Form.Control type="text" defaultValue={admin.fullName} {...register("fullName")} placeholder="Enter hod name" />
            </Form.Group>

            <Form.Group className="mb-3" controlId="years">
              <Form.Label>Year Access</Form.Label>
              <Controller
                name={"years"}
                control={control}
                render={({ field: { value, onChange, onBlur } }) => {
                  return (
                    <Select
                      options={OPTIONS}
                      placeholder={"Choose years..."}
                      isMulti={true}
                      onChange={(options) =>
                        onChange(options?.map((option) => option.value))
                      }
                      onBlur={onBlur}
                      value={OPTIONS.filter((option) => value?.includes(option.value))}
                      defaultValue={OPTIONS.filter((option) =>
                        value?.includes(option.value)
                      )}
                    />
                  );
                }}
              />
            </Form.Group>
            {/* <div className="form-group col-md-4">
            <label for="semesters" className="addDlabel">
              Assigned Years
            </label>
        
          </div> */}
          <div style={{display:'flex',justifyContent:"center"}}>
          <Button variant="primary" type="submit" className='modalbutton'>
              Save
            </Button>

          </div>
                      </Form>
        </Modal.Body>
      </Modal>
    </>
  )
}
// batch=18
// years=[3,1,7]=><>Current-R-{batch-y+1}</>
// R-18 (Current)
// R-17



export default AdminModal



